// material-ui
import React, { useEffect, useState } from 'react';
import { Box, FormControl, Grid, InputAdornment, Link, OutlinedInput } from '@mui/material';
// assets
import { SearchOutlined } from '@ant-design/icons';
import Typography from "@mui/material/Typography";
import { center } from 'underscore.string';

// ==============================|| HEADER CONTENT - SEARCH ||============================== //

const Search = () => {
  // Define state to hold menuTitle
  var a = window.location.pathname;
  var b = a.split("/").map(item => item.toUpperCase());
  if (b.length === 2 && b.every(item => item === '')) {
    // If b is empty, assign "DASHBOARD" to it
    b = ["", "DASHBOARD"];
  }

  return (
    <Box sx={{ width: '100%', ml: { xs: 0, md: 1 } }}>
      <Grid container spacing={2}>
        <Grid item xs={10}>
          <Typography variant='body1' sx={{
            fontSize: "large",
          }} >{b[1]}</Typography>
        </Grid>
        <Grid item xs={2} sx={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          color: "black",
        }}>
          <Link
            className="help"
            target="_blank"
            rel="noreferrer"
            href="https://indegene123.sharepoint.com/sites/WPS/SitePages/DSP-Editor.aspx?OR=Teams-HL&CT=1680672205605&clickparams=eyJBcHBOYW1lIjoiVGVhbXMtRGVza3RvcCIsIkFwcFZlcnNpb24iOiIyOC8yMzAzMDUwMTExMCIsIkhhc0ZlZGVyYXRlZFVzZXIiOmZhbHNlfQ%3D%3D"
            id="logo"
            underline="none" // optional, remove underline
            color="black"
          >
            Need Help?
          </Link>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Search;


{/* <FormControl sx={{ width: { xs: '100%', md: 224 } }}>
      <OutlinedInput
        size="small"
        id="header-search"
        startAdornment={
          <InputAdornment position="start" sx={{ mr: -0.5 }}>
            <SearchOutlined />
          </InputAdornment>
        }
        aria-describedby="header-search-text"
        inputProps={{
          'aria-label': 'weight'
        }}
        placeholder="Search here"
      />
    </FormControl> */}